import axios from 'axios';

const baseURL = 'api/Eje';

 async function getAll(language) {
     const { data } = await axios.get(baseURL + "?language=" + language);
     return data;
};

export default { getAll };  

